export type SkillRef = {
  skill?: { id?: string | number; name?: string | null };
};

export function extractOfferSkillIds(offerSkills: SkillRef[] | null | undefined): number[] {
  return (offerSkills ?? [])
    .map((item) => Number(item?.skill?.id))
    .filter((id) => Number.isFinite(id));
}

export function extractUserSkillIds(
  userSkills: SkillRef[] | null | undefined
): number[] {
  return (userSkills ?? [])
    .map((item) => Number(item?.skill?.id))
    .filter((id) => Number.isFinite(id));
}

export function userHasMatchingOfferSkill(
  userSkills: SkillRef[] | null | undefined,
  offerSkills: SkillRef[] | null | undefined
): boolean {
  const offerIds = extractOfferSkillIds(offerSkills);
  if (offerIds.length === 0) return true;
  const offerIdSet = new Set(offerIds);
  return extractUserSkillIds(userSkills).some((id) => offerIdSet.has(id));
}

export function getOfferSkillLabels(
  offerSkills: SkillRef[] | null | undefined
): string[] {
  return (offerSkills ?? [])
    .map((item, index) => {
      const name = item?.skill?.name?.trim();
      return name || `Rubro ${index + 1}`;
    })
    .filter(Boolean);
}
